module.exports = __webpack_public_path__ + "img/tech-pic_03.6baab4fb.png";